import { render, staticRenderFns } from "./StartSale.vue?vue&type=template&id=0b1824f8&scoped=true"
import script from "./StartSale.vue?vue&type=script&lang=js"
export * from "./StartSale.vue?vue&type=script&lang=js"
import style0 from "./StartSale.vue?vue&type=style&index=0&id=0b1824f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1824f8",
  null
  
)

export default component.exports